const config = {
    // URLs
    MAIN_SITE_URL: 'https://saviartmedia.com/',
    DASHBOARD_URL: 'https://dash.saviartmedia.com/',
    MAIN_WEBSOCKET_URL: 'wss://saviartmedia.com/ws/',
    SECONDARY_WEBSOCKET_URL: 'wss://tvrewards.net/ws/',

    // Site Information
    SITES: {
        MAIN: {
            NAME: 'SaviartMedia',
            URL: 'saviartmedia.com'
        },
        SECONDARY: {
            NAME: 'TVRewards',
            URL: 'tvrewards.net'
        }
    },

    // WebSocket Endpoints
    WEBSOCKET_ENDPOINTS: {
        TIMELINE: 'timeline/',
        CHAT: 'chat/'
    },

    // Contact Information
    CONTACT: {
        DEVELOPER: {
            NAME: 'Nguyễn Sơn',
            FACEBOOK: 'https://www.facebook.com/blue.outtatime/',
            PHONE: '+84335190991'
        }
    },
  
    // UI Constants
    UI: {
        COPYRIGHT_YEAR: 2025,
        COPYRIGHT_TEXT: "All Rights Reserved",
        TRADEMARK: "™"
    }
};

export default config; 